export default __webpack_public_path__ + "static/media/five.34405b70.png";